export class Language {
	languageCode: string;
	languageName: string;
	languageNativeName: string;

	constructor(languageCode: string = null, languageName: string = null, languageNativeName: string = null) {
		this.languageCode = languageCode;
		this.languageName = languageName;
		this.languageNativeName = languageNativeName;
	}

	getLanguageDropDownName(): string {
		if (this.languageNativeName && this.languageNativeName !== '' && this.languageNativeName !== 'English') {
			return `${this.languageName} (${this.languageNativeName})`;
		}

		return this.languageName;
	}
}
